import {Alert, Col, Row} from 'antd';
import {useEffect, useState} from 'react';
import {Redirect, Route, Switch, useRouteMatch} from 'react-router-dom';
import {HorizontalNav} from 'src/components';
import {HorizontalNavSize} from 'src/components/HorizontalNav';
import {NETWORK} from 'src/constants';
import {useWeb3Provider} from 'src/hooks';
import Artists from './Artists';
import Arts from './Arts';
import styles from './index.module.scss';

export default function MeRoutes() {
  const {path} = useRouteMatch();
  const {provider, isWallet} = useWeb3Provider();
  const [isWrongNetwork, setIsWrongNetwork] = useState(false);

  useEffect(() => {
    async function check() {
      if (!provider) {
        return;
      }
      setIsWrongNetwork((await provider.getNetwork()).chainId !== NETWORK.chainId);
    }

    check();
  }, [provider]);

  return isWallet ? (
    isWrongNetwork ? (
      <Alert
        message="Change Your Wallet's Network"
        description={`Please select the '${NETWORK.name}' network in your wallet`}
        type='warning'
        showIcon
      />
    ) : (
      <>
        <Row>
          <Col span={24}>
            <div className={styles.nav}>
              <HorizontalNav
                size={HorizontalNavSize.Small}
                links={[
                  [`${path}/artists`, 'My Artists'],
                  [`${path}/arts`, 'My Art'],
                ]}
              />
            </div>
          </Col>
        </Row>
        <Switch>
          <Route path={`${path}/artists`}>
            <Artists />
          </Route>

          <Route path={`${path}/arts`}>
            <Arts />
          </Route>

          <Redirect to={`${path}/artists`} />
        </Switch>
      </>
    )
  ) : (
    <Row>
      <Col span={24}>
        <Alert
          showIcon
          type='info'
          message='Connect Wallet'
          description='Please connect your wallet to mint artists and art'
        />
      </Col>
    </Row>
  );
}
